import { defaultTo } from 'ramda';
import { EPackageServiceType } from '../../../../../../PayPackageMicrofrontend';

const SERVICE_NAMES = {
  [EPackageServiceType.Top]: 'Топ',
  [EPackageServiceType.Premium]: 'Премиум',
  [EPackageServiceType.Paid]: 'Публикации',
  [EPackageServiceType.Standard]: 'Стандарт',
  [EPackageServiceType.Auction]: 'Баллы',
};

export const getServiceName = (serviceName: EPackageServiceType): string => {
  return defaultTo('', SERVICE_NAMES[serviceName]);
};
